import { useEffect, useState } from 'react';
import { TableColumnType } from 'antd';

const breakPoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};

export type Breakpoint = keyof typeof breakPoints;

export function useReactiveColumns<Row, T extends TableColumnType<Row> = TableColumnType<Row>>(
  tableColumn: T[],
  currentBreakPoint: Breakpoint
) {
  const [displayColumnList, setDisplayColumnList] = useState([] as T[]);
  const [hideColumnList, setHideColumnList] = useState([] as T[]);
  const displayColumns = (lhs?: Breakpoint, rhs?: Breakpoint) => {
    const largerBreakPoints = {
      xs: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
      sm: ['sm', 'md', 'lg', 'xl', 'xxl'],
      md: ['md', 'lg', 'xl', 'xxl'],
      lg: ['lg', 'xl', 'xxl'],
      xl: ['xl', 'xxl'],
      xxl: ['xxl']
    };
    if (!lhs) {
      return true;
    }
    const larger = largerBreakPoints[lhs];
    return rhs ? larger.includes(rhs) : false;
  };

  useEffect(() => {
    setDisplayColumnList(tableColumn.filter((item) => displayColumns(item.responsive?.[0], currentBreakPoint)));
    setHideColumnList(tableColumn.filter((item) => !displayColumns(item.responsive?.[0], currentBreakPoint)));
  }, [currentBreakPoint, tableColumn]);

  return [displayColumnList, hideColumnList] as [T[], T[]];
}
export default useReactiveColumns;
